import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import '@fontsource-variable/roboto-flex';
import 'material-symbols/outlined.css';
import '@iqueue/iq-ui/styles.css';
import App from './App';

// Follow the system theme (initial value is set inline in index.html)
const themeMedia = window.matchMedia('(prefers-color-scheme: light)');
const applyTheme = () => document.documentElement.setAttribute('data-theme', themeMedia.matches ? 'light' : 'dark');
applyTheme();
themeMedia.addEventListener('change', applyTheme);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
